var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import classNames from 'classnames';
import useTaroBaseEvents from '../_util/hooks/useTaroBaseEvents';
import useIntersection from '../_util/hooks/useIntersection';
import { createTaroEvent } from '../_util/taroEvent';
const Image = (_a, ref) => {
    var { className, src, mode = 'scaleToFill', lazyLoad = false, onError, onLoad } = _a, rest = __rest(_a, ["className", "src", "mode", "lazyLoad", "onError", "onLoad"]);
    const props = useTaroBaseEvents(rest);
    const [setRef, isIntersected] = useIntersection({
        rootMargin: '50px',
        disabled: !lazyLoad
    });
    const div = useRef(null);
    useImperativeHandle(ref, () => div.current);
    let isLazy = lazyLoad;
    if (!src || src.startsWith('data:') || src.startsWith('blob:')) {
        isLazy = false;
    }
    const isVisible = !isLazy || isIntersected;
    useEffect(() => {
        if (src && (onLoad || onError)) {
            const img = new window.Image();
            img.src = src;
            img.onerror = () => {
                if (onError) {
                    const detail = {
                        errMsg: 'something wrong'
                    };
                    const taroEvent = createTaroEvent('error', div.current, detail);
                    onError(taroEvent);
                }
            };
            img.onload = () => {
                if (onLoad) {
                    const detail = {
                        height: img.height,
                        width: img.width
                    };
                    const taroEvent = createTaroEvent('load', div.current, detail);
                    onLoad(taroEvent);
                }
            };
        }
    }, [src]);
    return (_jsx("div", Object.assign({ className: classNames('taro-img', className) }, props, { children: _jsx("div", { ref: el => {
                div.current = el;
                setRef(el);
            }, className: classNames('taro-img__content', {
                'taro-img__scale-to-fill': mode === 'scaleToFill',
                'taro-img__aspect-fit': mode === 'aspectFit',
                'taro-img__aspect-fill': mode === 'aspectFill',
                'taro-img__width-fix': mode === 'widthFix',
                'taro-img__height-fix': mode === 'heightFix',
                'taro-img__top': mode === 'top',
                'taro-img__bottom': mode === 'bottom',
                'taro-img__center': mode === 'center',
                'taro-img__left': mode === 'left',
                'taro-img__right': mode === 'right',
                'taro-img__top-left': mode === 'top left',
                'taro-img__top-right': mode === 'top right',
                'taro-img__bottom-left': mode === 'bottom left',
                'taro-img__bottom-right': mode === 'bottom right'
            }), style: {
                backgroundImage: isVisible && src ? `url(${src})` : undefined
            } }) })));
};
export default forwardRef(Image);
